import React from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";

const WhatsAppFab = () => (
  <motion.a
    initial={{ scale: 0, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ delay: 1.4, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
    href="https://wa.me/966590960314"
    target="_blank"
    rel="noreferrer"
    data-testid="whatsapp-fab"
    aria-label="WhatsApp"
    className="fixed bottom-6 end-6 z-40 h-14 w-14 rounded-full flex items-center justify-center bg-[color:var(--sw-orange)] text-black shadow-[0_18px_40px_-15px_rgba(242,101,34,0.75)] hover:bg-[color:var(--sw-amber)] transition-colors"
  >
    <MessageCircle size={22} />
    <span className="absolute inline-flex h-full w-full rounded-full bg-[color:var(--sw-orange)] opacity-40 animate-ping" />
  </motion.a>
);

export default WhatsAppFab;
